import {importLazyFrame} from "./kp-util";

let iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"], .lazyframe')

if (iframes.length > 0) {
  importLazyFrame().then((lazyframe) => {
    lazyframe(iframes);
  })
}